// AB Maturity Latency isLatencyTest ab_maturity_latency

import { Chip, Tooltip } from '@evaneos/b2b-ui';
import ScienceIcon from '@evaneos/b2b-ui/icons/Science';
import { useIntl } from 'react-intl';

type Props = {
    size?: 'small' | 'medium';
    className?: string;
};

export const ABMaturityLatencyExperimentChip = ({ size = 'small', className }: Props) => {
    const { formatMessage } = useIntl();
    const tooltipText = formatMessage({ id: 'ab_maturity_latency.pipeline.tooltip' });

    return (
        <Tooltip title={tooltipText} arrow placement="top">
            <Chip
                icon={<ScienceIcon />}
                label=""
                size={size}
                variant="outlined"
                className={className}
                sx={{
                    minWidth: 'auto',
                    height: 24,
                    width: size === 'small' ? 24 : 32,
                    borderRadius: 16,
                    backgroundColor: '#00E676',
                    border: '1px solid #00C853',
                    boxShadow: '0 0 8px rgba(0, 230, 118, 0.4)',
                    '& .MuiChip-label': {
                        display: 'none',
                    },
                    '& .MuiChip-icon': {
                        margin: 0,
                        fontSize: size === 'small' ? 16 : 20,
                        color: '#000000',
                    },
                    '&:hover': {
                        backgroundColor: '#00E676',
                        boxShadow: '0 0 12px rgba(0, 230, 118, 0.6)',
                    },
                }}
            />
        </Tooltip>
    );
};
